import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// The icon prop can be either a string or array.
// A string specifies the icon name
// from the normal 'solid' library.
// An array specifies the prefix
// of the icon library, and then the icon name.
// e.g. ['fal', 'flag'] => 'Font Awesome Light Icons', 'Flag Icon'
// See https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
const Icon = ({ fixedWidth, icon, onClick, styleName, size, ...props }) => {
  return (
    <FontAwesomeIcon
      fixedWidth={fixedWidth}
      icon={icon}
      onClick={onClick}
      styleName={styleName}
      size={size}
      {...props}
    />
  );
};

Icon.propTypes = {
  fixedWidth: PropTypes.bool,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  onClick: PropTypes.func,
  styleName: PropTypes.string,
  size: PropTypes.string
};

Icon.defaultProps = {
  fixedWidth: false,
  onClick: () => {},
  styleName: null,
  size: null
};

export default Icon;
